import { Box, TextField } from "@mui/material";
import React, { FC, useState } from "react";
import useResponsive from "../../hooks/useResponsive";

const inputSty = {
  border: "none",
  outline: "none",
  height: 40,
  backgroundColor: "transparent",
  width: "90%",
  fontFamily: "Poppins",
  fontSize: 13,

  color: "#000",
  fontWeight: 500,
  "& placeholder": {
    color: "#92A5B5",
  },
};

const Search: FC<{
  placeholder: string;

  submit: (search: string) => void;
}> = ({ placeholder, submit }) => {
  const isDesktop = useResponsive("down", "lg", "xl");
  const isMedium = useResponsive("down", "md", "xs");
  const [search, setSearch] = useState("");

  const submit_handler = (e: any) => {
    e.preventDefault();
    submit(search);
  };
  return (
    <>
      <Box
        component={"form"}
        sx={{
          width: 350,
          height: 45,
          backgroundColor: "#ffffff",
          borderRadius: 30,
          border: "1px solid #E7EBEF",
          display: "flex",
          gap: "6px",
          paddingX: 2,
          alignItems: "center",
          cursor: "pointer",
        }}
        onSubmit={submit_handler}
      >
        <img src="/assets/icons/search.svg" alt="" width={18} height={18} />
        <input
          style={inputSty}
          placeholder={placeholder}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Box>
    </>
  );
};

export default Search;

export const DashboardSearch: FC<{
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ placeholder, onChange, value }) => {
  return (
    <>
      <Box
        sx={{
          width: 200,
          height: 45,
          backgroundColor: "#ffffff",
          borderRadius: 30,
          border: "1px solid #E7EBEF",
          display: "flex",
          gap: "6px",
          paddingX: 2,
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <img
          src="/assets/icons/search-icon.svg"
          alt=""
          width={18}
          height={18}
        />
        <input
          style={inputSty}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      </Box>
    </>
  );
};
